var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"supply"},[_c('img',{staticClass:"supply-img",attrs:{"src":_vm.imgUrl,"alt":"banner图"}}),(_vm.activeName)?_c('div',{class:_vm.activeName,on:{"click":_vm.danclick}},[_vm._v(" "+_vm._s(_vm.btnText)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }